import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchData } from "../../../api/cancuiApi";

const useGetPressureLookupTemperature = () => {
    const [pressureLookupData, setPressureLookupData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        fetchData("getLookupTable", {})
            .then((res) => {
                console.log("PressureLookupTemperature response:", res);
                if (res.objs && res.objs.length > 0) {
                    setPressureLookupData(res.objs);
                } else {
                    setPressureLookupData([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching PressureLookupTemperature:", error);
                toast.error("Error fetching PressureLookupTemperature. Please try again later.");
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return { pressureLookupData, loading };
};


export default useGetPressureLookupTemperature;